import axios from 'axios';

const widgetsList = {
    "NOTIFICATION" : {
        name: 'Notification',
        description: 'Display purchases, signup, review in real time',
        img: 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678112-bag-256.png',
    },
    "INFORMATIONAL" : {
        name: 'Cookie Consent',
        description: 'Be GPDR compliant with a simple cookie consent widget',
        img: '//cf.appdrag.com/eikyo-ed330e/uploads/1585940042894-3856385.svg'
    },
    "RATING" : {
        name: 'Users feedback',
        description: 'Enable your users to rate their experience',
        img: 'https://cdn3.iconfinder.com/data/icons/survey-color/512/Survey_rating_rate-08-256.png'
    },
};

const widgetsListComingSoon = {
    "NEWSLETTER_SUBSCRIBE" : {
        name: 'Newsletter subscribption',
        description: 'Collect email addresses to grow your newsletter subscription list',
        img: 'https://cdn2.iconfinder.com/data/icons/seo-flat-6/128/39_Email_Marketing-256.png'
    },
    "SOCIAL_SHARE" : {
        name: 'Social medias share',
        description: 'Let your customers boost your visits by sharing your content on social medias',
        img: 'https://cdn0.iconfinder.com/data/icons/social-media-2183/512/social__media__social_media__share_-256.png'
    }
}

export default  {
    namespaced: true,
    state: { 
        namespaced: true,
        widgets: {}, 
        widget: null,
        status: '',
        domainName: '',
        domainExtension: '',
        creationStatus: '',
        widgetStatus: '',
        widgetsList: widgetsList,
        widgetsListComingSoon: widgetsListComingSoon,
    },
    getters: { 
        widgets: state => state.widgets,
        status: state => state.status,
        creationStatus: state => state.creationStatus,
        widgetStatus: state => state.widgetStatus
    },
    mutations: { 
        WIDGETS_RETRIEVED: (state, widgets) => {
            state.status = '';
            if (widgets.Table == undefined) {
                state.widgets = {};
            } else {
                widgets.Table.forEach(function (widget) {
                    state.widgets[widget.type] = widget;
                    state.widgetsList[widget.type].enabled = widget.enabled;
                });
            }
            state.domainName = widgets.domainName;
            state.domainExtension = widgets.domainExtension;
        },
        WIDGETS_LOADING: (state) => {
            state.domainName = '';
            state.domainExtension = '';
            state.status = 'loading'
        },
        WIDGET_LOADING: (state) => {
            state.widget = null;
            state.widgetStatus = 'loading'
        },
        WIDGET_SAVING: (state) => {
            state.widgetStatus = 'saving'
        },
        WIDGET_SAVED: (state) => {
            state.widgetStatus = 'saved'
        },
        DOMAIN_EDITED: (state, domain) => {
            state.domainName = domain.name;
            state.domainExtension = domain.domain;
        },
        WIDGET_RETRIEVED: (state, data) => {
            state.domainName = data.domainName;
            state.domainExtension = data.domainExtension;
            let widget = data.widget;
            if (typeof(widget.config) == "string") {
                widget.config = JSON.parse(widget.config);
            }
            if (widget.config.rules == undefined) {
                widget.config.rules = {
                    allPages : true,
                    pages: [],
                    displayMode: 'delay',
                    displayDelayValue: 5000,
                    displayScrollValue: 50,
                };
            }
            if (widget.config.rules.pages == undefined) {
                widget.config.rules.pages = [{value : ''}];
            }
            if (widget.config.rules.pages.length == 0) {
                widget.config.rules.pages = [{value : ''}];
            }
            if (widget.config.style == undefined) {
                widget.config.style = '';
            }
            state.widgetStatus = 'loaded';
            state.widget = widget;
        },
        WIDGETS_CREATING: (state) => {
            state.creationStatus = 'loading'
        },
        WIDGETS_CREATED: (state) => {
            state.creationStatus = ''
        }
    },
    actions: { 
        DOMAIN_WIDGETS: ({commit, state, rootState}, domain) => {
            return new Promise((resolve) => { // The Promise used for router redirect in login
              state;
              commit("WIDGETS_LOADING")
              axios({url: 'https://www.eikyo.pro/api/getWidgetsForDomain', data: {
                token: rootState.token,
                domain: domain,
              }, method: 'POST' })
                .then(resp => {
                  commit("WIDGETS_RETRIEVED", resp.data.payload)
                  resolve(resp)
                })
            })
          },
        CREATE_WIDGET: ({commit, state, rootState}, widget) => {
            return new Promise((resolve) => { // The Promise used for router redirect in login
                state;
                commit("WIDGETS_CREATING")
                axios({url: 'https://www.eikyo.pro/api/widgets/create', data: {
                  token: rootState.token,
                  domain: widget.domain,
                  name: widget.name,
                  type: widget.type,
                }, method: 'POST' })
                  .then(resp => {
                    commit("WIDGETS_CREATED")
                    resolve(resp.data.payload.Table[0]['newID'])
                  })
              })
        },
        LOAD_WIDGET: ({commit, state, rootState}, data) => {
            return new Promise((resolve) => { // The Promise used for router redirect in login
                state;
                commit("WIDGET_LOADING")
                axios({url: 'https://www.eikyo.pro/api/widgets/get', data: {
                  token: rootState.token,
                  widget: data.widget,
                  domain: data.domain,
                }, method: 'POST' })
                  .then(resp => {
                    commit("WIDGET_RETRIEVED", resp.data.payload)
                    resolve(resp)
                  })
              })
        },
        DELETE_WIDGET:({commit, state, rootState}, data) => {
            return new Promise((resolve) => { // The Promise used for router redirect in login
                state;
                commit;
                axios({url: 'https://www.eikyo.pro/api/widgets/delete', data: {
                  token: rootState.token,
                  widget: data.widget,
                  domain: data.domain,
                }, method: 'POST' })
                  .then(resp => {
                    resolve(resp)
                  })
              })
        },
        SAVE_WIDGET:({commit, state, rootState}, widget) => {
            return new Promise((resolve) => { // The Promise used for router redirect in login
                state;
                commit("WIDGET_SAVING")
                axios({url: 'https://www.eikyo.pro/api/widgets/save', data: {
                  token: rootState.token,
                  widget: widget.type,
                  domain: widget.domain,
                  enabled: widget.enabled ? '1' : '0',
                  config: JSON.stringify(widget.config),
                }, method: 'POST' })
                  .then(resp => {
                    commit("WIDGET_SAVED")
                    resolve(resp)
                  })
              })
        }
     },
  }
  